import React from 'react'
import arrayMove from 'array-move'
import styled from 'styled-components'

import { 
    Empty, Button, Icon, Divider,
} from 'antd'

import Util from '../../../../../post/Tab.Content/util'

import Footer from './Footer'
import Grid from './Grid'

const Container = styled.div`
    overflow-x: auto;

    background-color: #f9f9f9;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    /* margin-top: 16px; */

    /* padding: 4px;

    @media (min-width: 768px)
    {
        padding: 8px;
    } */
`

const Center = styled.div`

    background-color: #f9f9f9;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    display: flex;

    flex-direction: column;

    align-items: center;
    justify-content: center;

    height: 100%;
    padding: 24px 0 48px 0;

    /* margin-top: 16px; */

    .ant-empty
    {
        padding: 24px;
    }
`

const Note = styled.small`
    display: flex;

    flex-direction: row;
    flex-wrap: nowrap;

    align-items: center;
    justify-content: flex-start;

    padding: 8px;

    i
    {
        margin-right: 8px;
    }
`

function Comp (
    {
        title = '',

        action,

        name,
        value = [],

        onChange,
        onUploading,

        createTemp,
    }
)
{
    function handleChange (action, index, node)
    {
        if (typeof onChange === 'function')
        {
            if (action === 'add')
            {
                onChange(name, Util.add(value, index, node))
            }
            else if (action === 'edit')
            {
                onChange(name, Util.edit(value, index, node))
            }
            else if (action === 'remove')
            {
                onChange(name, Util.remove(value, index))
            }
        }
    }

    function handleAdd ()
    {
        const id = new Date ().getTime ().toString (35)

        handleChange ('add', -1, { id })
    }

    function handleSort ({ oldIndex, newIndex })
    {
        onChange(name, arrayMove (value, oldIndex, newIndex))
    }

    if (value.length === 0)
    {
        return (
            <Center>
                {!!title && <Divider type="horizontal" orientation="center">{title}</Divider>}
                <Empty description="ไม่มีข้อมูล" />
                <Button 
                    title="เพิ่มสถานที่"
                    type="primary" 
                    icon="plus" 
                    disabled={!!action}
                    onClick={() => handleAdd()}
                >
                    เพิ่มสถานที่
                </Button>
            </Center>
        )
    }

    return (
        <Container id="content-editor">
            {!!title && <Divider type="horizontal" orientation="center">{title}</Divider>}
            {
                value.length > 1 &&
                <Note>
                    <Icon type="info-circle" /> คลิกที่ :: ค้างไว้แล้วลากเพื่อเปลี่ยนแปลงลำดับ
                </Note>
            }
            <Grid 
                axis="y"
                useDragHandle={true}

                action={action}
                contents={value}
                createTemp={createTemp}

                onChange={handleChange}
                onUploading={onUploading}

                onSortEnd={handleSort}
            />
            <Footer 
                disabled={!!action}
                onAdd={handleAdd}
            />
        </Container>
    )
}

export default Comp